<template>
    <svg
        class="w-4 h-4"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        xmlns="http://www.w3.org/2000/svg"
    >
        <!-- Empty checkbox outline -->
        <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" fill="none"/>
    </svg>
</template>
